import { Style } from 'geostyler-style';

const styleTemplate: Style = {
  name: 'NDVI_DBZ',
  rules: [
    {
      name: '',
      symbolizers: [
        {
          kind: 'Raster',
          colorMap: {
            type: 'ramp',
            colorMapEntries: [
              {
                color: '#003cff',
                quantity: 0,
                opacity: 0,
              },
              {
                color: '#003cff',
                quantity: 2,
                opacity: 1,
              },
              {
                color: '#00c7c7',
                quantity: 7,
                opacity: 1,
              },
              {
                color: '#00a8ac',
                quantity: 12,
                opacity: 1,
              },
              {
                color: '#008261',
                quantity: 18,
                opacity: 1,
              },
              {
                color: '#009637',
                quantity: 21,
                opacity: 1,
              },
              {
                color: '#00c027',
                quantity: 23,
                opacity: 1,
              },
              {
                color: '#00e80a',
                quantity: 28,
                opacity: 1,
              },
              {
                color: '#24ff24',
                quantity: 34,
                opacity: 1,
              },
              {
                color: '#ffff1e',
                quantity: 37,
                opacity: 1,
              },
              {
                color: '#ffe600',
                quantity: 39,
                opacity: 1,
              },
              {
                color: '#ffbc00',
                quantity: 44,
                opacity: 1,
              },
              {
                color: '#ff9800',
                quantity: 50,
                opacity: 1,
              },
              {
                color: '#ff5e00',
                quantity: 53,
                opacity: 1,
              },
              {
                color: '#f20f00',
                quantity: 55,
                opacity: 1,
              },
              {
                color: '#bb003a',
                quantity: 60,
                opacity: 1,
              },
              {
                color: '#ff00ff',
                quantity: 66,
                opacity: 1,
              },
              {
                color: '#ff00ff',
                quantity: 72,
                opacity: 1,
              },
            ],
          },
          contrastEnhancement: {},
        },
      ],
    },
  ],
};

export default styleTemplate;
